import RestClient from './rest-client'

export default class Setting extends RestClient {
  static get url () {
    return this.apiUrl + '/settings'
  }
  
  static get paramKey () {
    return 'setting'
  }

  static async byKey (key) {
    const { data } = await this._get(this.url + `/${key}/by_key`)

    return new this(data.data)
  }

  static async register_user_flag () {
    const { data } = await this._get(this.url + `/get_register_flag`)

    return new this(data.data)
  }
}
